module.exports = require('./helpers/bundle-url').getBundleURL('dKtRO') + "logo.c51670a8.svg";